export const NUMBER_OF_ELEMENTS = 11;
